import { Resource } from '@domain/base/Resource';
import { IImportJobsRepository } from '@domain/connection/IMarketplaceRepository';
import { ActiveImportJob, ImportJobStatus } from '@domain/connection/models/ImportJob';
import { ImportJobsDataSource } from '../datasources/ImportJobsDataSource';

export class ImportJobsRepository implements IImportJobsRepository {

    constructor(private dataSource: ImportJobsDataSource) { }

    async fetchJobStatus(connector: string, jobId: string): Promise<Resource<ImportJobStatus>> {
        try {
            const data = await this.dataSource.fetchJobStatus(connector, jobId);
            return { status: 'success', data };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to fetch job status'
                }
            };
        }
    }

    async fetchActiveJobs(): Promise<Resource<ActiveImportJob[]>> {
        try {
            const data = await this.dataSource.fetchActiveJobs();
            return { status: 'success', data };
        } catch (error) {
            return {
                status: 'error',
                error: {
                    type: 'UnknownError',
                    message: 'Failed to fetch active jobs'
                }
            };
        }
    }
}
